// extracted by mini-css-extract-plugin
export default {"title":"jGUhX","name":"oYVoB","period":"a2ISL"};